import React, { memo } from 'react';
import { MediaBarChart } from 'components/MediaBarChart';

export const CollectionMediaTotal = memo(({ data }) => {
  return <MediaBarChart data={data} title="Tíðni umfjöllunar eftir miðlum" />;
});
